import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AlertService } from '../alert.service';
import { UnsavedDataCheck } from '../../types/unsaved-data-check';

@Injectable()
export class UnsavedDataGuard implements CanDeactivate<UnsavedDataCheck> {
    constructor(
        private alert: AlertService
    ) {}

    canDeactivate(
        component: UnsavedDataCheck,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState: RouterStateSnapshot
    ): Observable<boolean>|Promise<boolean>|boolean {

        if(!component.hasUnsavedData()) {
            return true;
        }

        return this.alert.confirm('Do you want to delete unsaved data?', 'Close without saving?');
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/guards/unsaved-data-guard.service.ts